<template src="./template.html"></template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import eventService from 'api/event'
import dateUtils from 'utils/dateUtils'
import EventCard1 from 'components/EventCard1'

export default {
  name: 'event-flyer',
  props: {
    eventId: {
      type: String,
      required: true,
    },
    buttonBgColor: {
      type: String,
    },
    buttonTextColor: {
      type: String,
    },
    buttonText: {
      type: String,
      default: 'View tables and tickets',
    },
    theme: {
      type: String,
      default: 'theme-light',
    },
  },
  components: {
    EventCard1,
  },
  data() {
    return {
      event: null,
      loading: false,
      eventNotFound: false,
    }
  },
  methods: {
    getEvent() {
      return eventService
        .getById(this.eventId, {
          fields: ['venue()'].join(','),
        })
        .then((event) => {
          this.event = event
        })
    },
    onEventClicked() {
      this.$emit('eventClicked', this.event)
    },
    onUpdated() {
      this.$emit('updated')
    },
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      inventory: (state) => state.inventory.current,
    }),
    wrapperClass() {
      if (this.imageSize === 'SMALL') {
        return 'flyer-small'
      }

      return ''
    },
    eventClass() {
      if (this.eventId === '7860cffa0ad8b47f') return 'event-vayner-sports'

      return ''
    },
    buttonBgColorSanitized() {
      if (!this.buttonBgColor) return null

      if (!this.buttonBgColor.startsWith('#')) return `#${this.buttonBgColor}`

      return this.buttonBgColor
    },
    buttonTextColorSanitized() {
      if (!this.buttonTextColor) return null

      if (!this.buttonTextColor.startsWith('#')) return `#${this.buttonTextColor}`

      return this.buttonTextColor
    },
  },
  created() {
    this.loading = true

    this.getEvent()
      .then(() => {
        this.$store.dispatch('setCurrentVenue', this.event.venue)

        let date = moment.utc(this.event.date, 'x')
        date = dateUtils.toUTCMomentWithoutTime(date)

        this.$store.dispatch('setCurrentDate', date)

        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        if (error.message === 'event not found') {
          this.eventNotFound = true
        }
      })
  },
  updated() {
    this.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EventFlyer/index.vue